export const ASSESSMENT_PREFIX = 'assessment';
